import "./index.scss"
import React, { useEffect, useRef } from "react"
import homeMonkeSolid from "../../../assets/images/home-monke.png"
import { gsap } from "gsap"
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"

export const Logo = () => {
  const bgRef = useRef(null)
  const outlineLogoRef = useRef(null)
  const solidLogoRef = useRef(null)

  useEffect(() => {
    gsap.registerPlugin(DrawSVGPlugin)

    gsap
      .timeline()
      .to(bgRef.current, { duration: 0.4, opacity: 1 })
      .fromTo(
        outlineLogoRef.current,
        { drawSVG: "0%" },
        { duration: 1.4, drawSVG: "15%", ease: "power3.out" }
      )
      .to(outlineLogoRef.current, {
        duration: 1.2,
        drawSVG: "100%",
      })

    gsap.fromTo(
      solidLogoRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: 0.8,
        duration: 1.2,
      }
    )
  }, [])

  return (
    <div ref={bgRef} className="logo-container">
      <img
        ref={solidLogoRef}
        className="solid-logo"
        src={homeMonkeSolid}
        alt="Logo"
      />
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="300.000000pt"
        height="550.000000pt"
        viewBox="0 0 300.000000 550.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        {" "}
        <g
          transform="translate(0.000000,550.000000) scale(0.100000,-0.100000)"
          fill="transparent"
          className="svg-logo"
        >
          <path
            ref={outlineLogoRef}
            d="M1027 5339 c-9 -6 -25 -9 -35 -8 -50 8 -193 -64 -270 -136 -45 -42 -71 -77 -106 -147 -58 -115 -76 -181 -76 -280 0 -97 31 -255 64 -330 82 -185 217 -305 551 -495 28 -15 94 -53 147 -83 53 -30 95 -57 92 -61 -2 -4 -19 -11 -37 -14 -17 -4 -38 -12 -45 -18 -7 -5 -15 -7 -19 -4 -3 4 -12 2 -19 -3 -6 -6 -16 -10 -20 -9 -5 2 -20 -2 -34 -8 -14 -6 -54 -21 -88 -34 -110 -39 -354 -202 -424 -284 -34 -40 -52 -116 -53 -220 0 -87 3 -106 25 -149 14 -27 41 -62 60 -78 96 -79 299 -77 381 4 16 17 33 28 36 24 18 -17 55 -193 60 -282 6 -100 6 -100 -22 -122 -22 -17 -36 -20 -73 -16 -26 3 -54 8 -62 11 -8 3 -25 5 -37 4 -11 -1 -24 3 -28 8 -7 12 -128 15 -139 4 -4 -5 -11 -8 -14 -9 -28 -3 -137 -58 -180 -91 -42 -31 -105 -117 -136 -185 -66 -142 -62 -235 14 -321 24 -27 31 -43 26 -60 -6 -26 14 -61 44 -77 25 -13 84 10 100 39 6 12 17 21 26 21 41 0 151 86 166 130 3 10 9 10 25 1 12 -6 28 -8 36 -5 11 4 18 -8 27 -48 37 -155 153 -259 306 -275 54 -6 56 -7 50 -32 -3 -14 -14 -66 -25 -115 -30 -135 -38 -323 -17 -425 22 -109 50 -182 90 -234 66 -87 136 -110 188 -60 36 34 35 56 -4 140 -29 61 -32 77 -33 164 0 92 1 98 42 180 23 46 88 145 144 219 134 176 173 242 209 348 66 197 109 595 95 868 -7 133 -7 134 14 134 65 0 162 72 206 151 26 48 30 64 30 139 0 151 -45 227 -215 368 -122 100 -279 206 -362 244 -20 9 -63 34 -96 56 -32 22 -105 64 -163 93 -200 101 -466 292 -579 416 -90 98 -140 220 -140 341 0 179 140 406 277 449 54 17 56 17 92 -3 46 -27 84 -96 75 -139 -15 -76 -52 -92 -124 -55 -22 11 -51 20 -65 20 -32 0 -85 -50 -85 -80 0 -38 28 -88 59 -104 40 -21 159 -21 209 0 78 32 136 111 148 202 8 65 -22 171 -68 229 -35 47 -108 88 -150 84 -14 -1 -29 2 -33 8 -8 13 -15 13 -38 0z m142 -48 c98 -50 152 -228 102 -337 -53 -117 -224 -171 -312 -97 -35 30 -39 73 -9 103 26 26 34 25 95 -5 78 -38 116 -30 141 30 29 71 4 162 -57 206 -94 67 -239 -13 -341 -187 -101 -173 -113 -323 -37 -483 44 -96 98 -162 202 -247 51 -42 102 -85 115 -96 52 -43 284 -188 392 -245 154 -81 180 -97 180 -107 0 -4 -7 -5 -16 -2 -8 3 -45 2 -81 -4 -86 -12 -110 -3 -320 116 -385 220 -496 314 -592 501 -51 102 -84 333 -61 434 20 92 95 232 158 296 128 131 321 185 441 124z m530 -1510 c101 -33 165 -124 225 -321 63 -208 97 -646 76 -985 -14 -233 -22 -298 -59 -447 -37 -147 -80 -237 -173 -358 -229 -300 -264 -371 -256 -521 5 -75 10 -96 37 -144 40 -70 39 -115 0 -129 -82 -28 -174 79 -215 251 -30 125 -16 399 30 552 12 42 15 45 65 58 64 16 137 57 158 89 13 21 17 22 30 9 8 -9 33 -15 59 -15 60 0 117 50 140 125 20 63 14 97 -27 137 -24 24 -34 28 -58 23 -28 -6 -30 -4 -36 32 -18 111 -89 226 -166 270 -87 50 -140 92 -153 124 l-12 29 -22 -23 c-12 -13 -24 -37 -28 -54 -5 -26 -12 -32 -43 -38 -51 -9 -161 -70 -193 -108 -16 -17 -28 -26 -28 -19 0 7 -12 17 -27 23 -79 30 -179 -103 -153 -203 6 -20 15 -40 20 -43 14 -9 -43 -85 -85 -114 -82 -56 -176 -31 -257 67 -56 67 -54 143 6 267 54 111 114 179 197 220 98 50 150 58 252 40 207 -37 256 -6 244 155 -12 154 -90 400 -127 400 -10 0 1 -45 19 -78 10 -19 7 -26 -21 -52 -46 -41 -90 -54 -183 -54 -126 0 -184 35 -241 144 -23 45 -24 172 -1 250 21 72 76 128 222 226 139 92 226 132 392 178 202 57 303 66 392 37z m266 -150 c148 -113 230 -194 262 -259 24 -50 28 -69 28 -147 0 -82 -3 -95 -31 -145 -25 -45 -40 -60 -85 -82 -70 -35 -121 -46 -113 -24 7 18 -22 263 -41 356 -27 124 -92 288 -148 369 l-31 46 29 -19 c17 -11 75 -53 130 -95z m-585 -1143 c0 -4 45 -37 100 -72 91 -59 102 -70 132 -128 49 -95 59 -127 59 -198 1 -154 -102 -288 -252 -326 -147 -38 -308 37 -379 175 -29 57 -45 181 -29 229 45 141 147 234 270 249 46 5 49 8 49 34 0 15 5 40 12 54 11 25 13 26 25 9 7 -10 13 -21 13 -26z m-353 -186 c9 -6 5 -21 -14 -60 -14 -29 -28 -75 -31 -102 -5 -59 -27 -67 -61 -24 -26 33 -27 74 -1 124 29 58 74 83 107 62z m756 -239 c26 -30 31 -70 12 -118 -27 -73 -99 -120 -144 -96 -21 12 -21 12 9 70 16 32 32 81 36 110 6 49 8 51 39 51 18 0 39 -8 48 -17z m-1111 -133 c28 0 21 -16 -12 -30 -25 -10 -34 -10 -55 4 -16 10 -25 26 -25 41 l0 25 37 -20 c21 -11 46 -20 55 -20z"
          />
        </g>
      </svg>
    </div>
  )
}
